import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Sun, ArrowRight } from "lucide-react";
import axios from "axios";
import { useI18n } from "../contexts/I18nContext";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

// Compact "today's horoscope" teaser for the customer dashboard.
export const TodayHoroscopeCard = () => {
  const navigate = useNavigate();
  const { t, lang } = useI18n();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await axios.get(`${API}/horoscope/today`, { params: { lang }, withCredentials: true });
        if (!cancelled) setData(res.data);
      } catch {}
      if (!cancelled) setLoading(false);
    })();
    return () => { cancelled = true; };
  }, [lang]);

  if (loading || !data) return null;

  const preview = (data.text || "").replace(/[*#>_`]/g, "").replace(/\s+/g, " ").slice(0, 190);

  return (
    <div data-testid="dash-horoscope-card" className="dash-section"
      style={{ background: "linear-gradient(135deg, rgba(255,209,102,0.09), rgba(157,78,221,0.05))", cursor: data.has_chart ? "pointer" : "default" }}
      onClick={() => data.has_chart && navigate("/horoscope")}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "10px", flexWrap: "wrap", gap: "8px" }}>
        <h2 style={{ color: "#FFD166" }}><Sun size={15} /> {t("horo.dashTitle")}</h2>
        <button data-testid="dash-horoscope-cta" onClick={(e) => { e.stopPropagation(); navigate(data.has_chart ? "/horoscope" : "/kundli"); }}
          style={{ background: "none", border: "none", cursor: "pointer", color: "#FFD166", fontSize: "0.82rem", display: "flex", alignItems: "center", gap: "4px" }}>
          {data.has_chart ? t("horo.dashCta") : t("chat.getKundli")} <ArrowRight size={14} />
        </button>
      </div>
      {data.has_chart ? (
        <>
          <div data-testid="dash-horoscope-headline" style={{ color: "white", fontWeight: 600, fontSize: "0.94rem", marginBottom: "5px" }}>
            {data.headline}
          </div>
          <p style={{ color: "rgba(255,255,255,0.55)", fontSize: "0.84rem", lineHeight: 1.6, margin: 0 }}>
            {preview}…
          </p>
        </>
      ) : (
        <p style={{ color: "rgba(255,255,255,0.5)", fontSize: "0.86rem", margin: 0 }}>{t("horo.dashEmpty")}</p>
      )}
    </div>
  );
};

export default TodayHoroscopeCard;
